// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
   display: block;
   min-width: 300px;
   width: 100%
}

.error {
   font-size: 13px;
   color: #d32f2f
}

mat-dialog-content {
   text-align: center
}

`, "",{"version":3,"sources":["webpack://./src/app/account/resend-verify-email/resend-verify-email.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,gBAAgB;GAChB;AACH;;AAEA;GACG,eAAe;GACf;AACH;;AAEA;GACG;AACH","sourcesContent":["mat-form-field {\n   display: block;\n   min-width: 300px;\n   width: 100%\n}\n\n.error {\n   font-size: 13px;\n   color: #d32f2f\n}\n\nmat-dialog-content {\n   text-align: center\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
